export interface OpenGraphData {
	ogType?: string
	ogTitle?: string
	ogDescription?: string
	ogUrl?: string
	ogImage?: string
	ogLocale?: string
	ogImageAlt?: string
	ogImageWidth?: string
	ogImageHeight?: string
	twitterCard?: string
	twitterTitle?: string
	twitterDescription?: string
	twitterImage?: string
	twitterImageAlt?: string
}

export function extractOpenGraphData(): OpenGraphData {
	const ogData: OpenGraphData = {}

	// Helper function to get meta content by property or name
	const getMetaContent = (
		property: string,
		name?: string,
	): string | undefined => {
		// Try property attribute first (for Open Graph)
		let meta = document.querySelector(`meta[property="${property}"]`)
		if (meta) {
			return meta.getAttribute("content") || undefined
		}

		// Try name attribute (for Twitter cards and other meta)
		if (name) {
			meta = document.querySelector(`meta[name="${name}"]`)
			if (meta) {
				return meta.getAttribute("content") || undefined
			}
		}

		return undefined
	}

	// Extract Open Graph data
	ogData.ogType = getMetaContent("og:type")
	ogData.ogTitle = getMetaContent("og:title")
	ogData.ogDescription = getMetaContent("og:description")
	ogData.ogUrl = getMetaContent("og:url")
	ogData.ogImage = getMetaContent("og:image")
	ogData.ogLocale = getMetaContent("og:locale")
	ogData.ogImageAlt = getMetaContent("og:image:alt")
	ogData.ogImageWidth = getMetaContent("og:image:width")
	ogData.ogImageHeight = getMetaContent("og:image:height")

	// Extract Twitter Card data
	ogData.twitterCard = getMetaContent("twitter:card", "twitter:card")
	ogData.twitterTitle = getMetaContent("twitter:title", "twitter:title")
	ogData.twitterDescription = getMetaContent(
		"twitter:description",
		"twitter:description",
	)
	ogData.twitterImage = getMetaContent("twitter:image", "twitter:image")
	ogData.twitterImageAlt = getMetaContent(
		"twitter:image:alt",
		"twitter:image:alt",
	)

	// Fallback to page title if og:title is not available
	if (!ogData.ogTitle) {
		ogData.ogTitle = document.title
	}

	// Fallback to current URL if og:url is not available
	if (!ogData.ogUrl) {
		ogData.ogUrl = window.location.href
	}

	// Fallback for description from standard meta description
	if (!ogData.ogDescription) {
		const description = getMetaContent("description", "description")
		if (description) {
			ogData.ogDescription = description
		}
	}

	return ogData
}
